<template>
    <template v-if="status.app === 'loaded'">
        <the-nav>
            <h3>
                Estás editando la plantilla <span style="color: black;">#{{ template.id }}</span> - <span
                class="text-section">

                <input type="text"
                       v-model="template.display_name"
                       @change="updateTemplateName"
                       @input="updateTemplateName">
                </span>
            </h3>

            <div class="buttons-container">
                <button
                    class="btn btn-light icon-wrapper"
                    @click="modal_to_show = 'update_roles_modal'"
                >
                    <i class="uq-icon bi-person"></i>
                </button>

                <button class="btn btn-warning icon-wrapper"
                        @click="showHelp">
                    <i class="uq-icon bi-question-diamond"></i>
                </button>

                <button class="btn btn-danger icon-wrapper"
                        v-if="can('template.destroy')"
                        @click="deleteTemplate">
                    <i class="uq-icon bi-trash"></i>
                </button>

                <button class="btn btn-primary"
                        :title="unedited_html_content === html_content ? 'No has hecho ningún cambio' : 'Guardar cambios'"
                        :disabled="unedited_html_content === html_content"
                        @click="saveChanges">Guardar cambios
                </button>
            </div>
        </the-nav>

        <div class="row" v-if="removeHtmlTags(html_content).length > emailCharactersLimit">
            <div class="col-12">
                <div class="alert alert-warning">
                    Esta plantilla <strong>es bastante larga</strong>. Puede que si se va a utilizar para el envío de correo electrónico falle. No obstante, verás un mensaje antes de enviarla como correo electrónico si no pudiese ser enviada.
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <html-editor height="80vh" width="100%" @contentChanged="fireEditorUpdated" @isLoaded="tinyMCEIsLoaded"
                             v-if="this.load_editor === true">>
                </html-editor>
            </div>

            <div class="col-6">
                <pdf-previewer :src="pdf_preview_content" height="80vh" width="100%"></pdf-previewer>
            </div>
        </div>
    </template>
    <div class="loader" v-else></div>

    <templates-edit-shortcodes-help-modal v-if="modal_to_show === 'shortcodes_help'"
                                          @closed="modal_to_show = null;">
    </templates-edit-shortcodes-help-modal>

    <templates-edit-roles-update-modal
        :template-id="template.id"
        :template-roles-ids="templateRolesIds"
        :available-roles="availableRoles"
        v-if="modal_to_show === 'update_roles_modal'"
        @closed="modal_to_show = null;"
    />
</template>

<script>

import PdfPreviewer from "../parts/PdfPreviewer";
import TemplatesListAddModal from "./parts/TemplatesListAddModal";
import HtmlEditor from "../parts/HtmlEditor";
import {can} from "../../../helpers/Permissions";
import {
    deleteTemplate,
    getTemplate,
    updateTemplate,
    updateTemplateDisplayName
} from "../../../helpers/requests/RequestsTemplates";
import router from "../../../router";
import {withTimeout} from "../../../helpers/requests/RequestsCore";
import {htmlToRawPreviewablePdf} from "../../../helpers/requests/RequestsPDFs";
import TheNav from "../../layouts/TheNav";
import TemplatesEditShortcodesHelpModal from "./parts/TemplateEditShortcodesHelpModal";
import TemplatesEditRolesUpdateModal from "./parts/TemplateEditRolesUpdateModal";
import {getRoles} from "../../../helpers/requests/RequestsRoles";

export default {
    name: "TemplateEdit",
    components: {
        TemplatesEditRolesUpdateModal,
        TemplatesEditShortcodesHelpModal,
        TheNav,
        HtmlEditor,
        TemplatesListAddModal,
        PdfPreviewer
    },
    props: {},
    data() {
        return {
            status: {
                app: 'loading',
                data: 'stored',
            },
            load_editor: false,

            pdf_preview_content: '',
            pdf_base64_content: '',
            template: {},
            unedited_html_content: '',
            html_content: '',

            modal_to_show: null,
            availableRoles: [],
            templateRolesIds: [],

            timers: {
                preview_pdf: '',
                name_updated: '',
            }
        }
    },
    computed: {
        // TODO: This is also used in TemplateEdit.vue. Move it to only change once if needed
        emailCharactersLimit() {
            return 1200;
        }
    },
    async mounted() {
        await this.loadTemplate();
        this.availableRoles = await getRoles();

        // TODO: Refactor this, please
        for (let allowedRole of this.template.allowed_roles) {
            for (let role of this.availableRoles) {
                if (role.name === allowedRole) {
                    this.templateRolesIds.push(role.id);
                    break;
                }
            }
        }

        this.status.app = 'loaded';
        this.load_editor = true;
    },
    methods: {
        removeHtmlTags(html) {
            let dom = new DOMParser().parseFromString(html, 'text/html');
            return dom.body.textContent;
        },
        async loadTemplate() {
            this.template = await getTemplate(router.currentRoute.value.params.template);
            this.html_content = this.template.content;
            this.unedited_html_content = this.template.content;
        },
        async updatePdfPreview() {
            this.timers.preview_pdf = withTimeout(async () => {
                await this.applyPdfPreview();
            }, this.timers.preview_pdf, 500);
        },
        async applyPdfPreview() {
            let html = this.html_content;
            // We force to push header and footer if existing
            if (!!this.template.header) {
                html = this.template.header + html;
            }
            if (!!this.template.footer) {
                html = this.template.footer + html;
            }

            let pdf_content = await htmlToRawPreviewablePdf(html);
            this.pdf_base64_content = escape(pdf_content);
            this.pdf_preview_content = "data:application/pdf;base64," + escape(pdf_content);
        },
        async fireEditorUpdated(data) {
            this.html_content = data.content;
            await this.updatePdfPreview();
        },
        async tinyMCEIsLoaded() {
            await tinymce.activeEditor.setContent(this.html_content);
            await this.applyPdfPreview();
            this.status.app = 'loaded';
        },
        showHelp() {
            this.modal_to_show = 'shortcodes_help';
        },

        updateTemplateName(e) {
            // Use a timeout to fire a template update
            let value = e.target.value;

            this.timers.name_updated = withTimeout(async () => {
                // Do store new value
                let res = await updateTemplateDisplayName(this.template.id, value);
                this.$store.dispatch('app/setToastMessage', 'Nombre cambiado con éxito');
            }, this.timers.name_updated, 250);
        },

        async saveChanges() {
            if (confirm('Vas a guardar los cambios. A partir de ahora, cuando se utilice esta plantilla se empleará como la has dejado. ¿Estás seguro?')) {
                // We force to store a default pagination footer by now
                let res = await updateTemplate(this.template.id, this.html_content);
                this.unedited_html_content = this.html_content;
                // Now redirect to templatesList (?)

                // TODO: This message to a modal
                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');
            }
        },
        async deleteTemplate() {
            if (confirm('¿Estás seguro de eliminar esta plantilla? Desaparecerá para siempre.')) {
                let res = await deleteTemplate(this.template.id);
                this.$store.dispatch('app/setToastMessage', 'Plantilla ' + this.template.display_name + ' borrada con éxito.');

                // redirect to templates
                await router.push({
                    name: 'template.index',
                });
            }
        }
    },
    setup() {
        return {
            router,
            can,
        }
    }
}
</script>
